import React, { memo } from 'react';
import PropTypes from 'prop-types';

const TeamsTableMobile = ({ teams }) => {
  return (
    <div className="cases-table-mobile">
      {teams.map((team) => {
        return (
          <div key={team.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{team.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {team.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

TeamsTableMobile.propTypes = {
  teams: PropTypes.array,
};

export default memo(TeamsTableMobile);
